export default __webpack_public_path__ + "static/media/kitchen4-afterE-1920w.72a2d838.webp";